module.exports = __webpack_public_path__ + "img/DSC_2751-xs.0a78a9c3.png";